export default __webpack_public_path__ + "static/media/home-hover.963578a0.svg";